import React, { useState } from 'react';
import { Button, Modal, Form, Row, Col } from 'react-bootstrap';
import { Formik, Field, FieldArray, ErrorMessage } from 'formik';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';
import * as Yup from 'yup';
import Select from 'react-select';
import { clientsService } from '../../services';

const EditClientModal = ({
  selectedClient,
  handleUpdateClientsList,
  breaksList,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  const [isSubmitting, setSubmitting] = useState(false);

  const updateClient = (data) => {
    setSubmitting(true);

    const clientParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      clientId: selectedClient._id,
      name: data.name,
      address: data.address,
      description: data.description,
      url: data.url,
      taxNo: data.taxNo,
      breakTypes:
        data.breaks?.length > 0
          ? data.breaks.map((breakItem) => ({
              breakId: breakItem.breakType.value,
              billable: breakItem.billable,
            }))
          : [],
    };

    clientsService
      .edit_client(clientParams)
      .then((response) => {
        if (response.data) {
          handleUpdateClientsList();
          handleClose();
        }
        setSubmitting(false);
      })
      .catch(() => {
        setSubmitting(false);
      });
  };

  const breakOptions =
    breaksList && breaksList.length > 0
      ? breaksList.map((breakItem) => {
          const bOption = {
            value: breakItem._id,
            label: breakItem.name,
          };
          return bOption;
        })
      : [];

  return (
    <>
      <Button variant="white" size="sm" onClick={handleShow}>
        <i className="mdi mdi-pencil" /> Edit
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="pt-4" closeButton>
          <Modal.Title>Edit Client</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize
          initialValues={{
            clientName: selectedClient.name,
            address: selectedClient.address,
            description: selectedClient.description
              ? selectedClient.description
              : '',
            website: selectedClient.url ? selectedClient.url : '',
            taxNo: selectedClient.taxNo,
            breaks:
              selectedClient.breakTypes.length > 0
                ? selectedClient.breakTypes.map((breakItem) => ({
                    breakType: {
                      label: breakItem.name,
                      value: breakItem.breakId,
                    },
                    billable: breakItem.billable,
                  }))
                : [],
          }}
          validationSchema={Yup.object({
            clientName: Yup.string()
              .trim()
              .required('Please enter client name'),
            breaks: Yup.array().of(
              Yup.object().shape({
                breakType: Yup.object().required('Break type is required'),
              })
            ),
            // description: Yup.string()
            //  .matches(/[a-z]+/g, 'Description should be alphanumeric')
            //  .min(10, 'Description must be more than 10 characters')
            //  .max(300, 'Description must be less than 300 characters'),
            // website: Yup.string()
            //  .matches(
            //    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
            //    'Please enter a valid url'
            //   )
            //  .min(4, 'Website url must be more than 3 characters'),
          })}
          onSubmit={(values) => {
            updateClient({
              name: values.clientName,
              address: values.address,
              description: values.description,
              taxNo: values.taxNo,
              url: values.website,
              breaks: values.breaks,
            });
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Modal.Body
                style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto' }}
              >
                <section>
                  <Form.Group controlId="clientName">
                    <Form.Label>
                      Client Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Field
                      className="form-control"
                      type="text"
                      placeholder=""
                      name="clientName"
                    />
                    <ErrorMessage
                      name="clientName"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>
                  <Form.Group controlId="clientName">
                    <Form.Label>Address</Form.Label>
                    <Tippy
                      content={`${'This will be reflected in invoices.'}`}
                      theme="light"
                      key="2"
                    >
                      <span className="p-2 d-inline-block">
                        <i className="mdi mdi-information-outline" />
                      </span>
                    </Tippy>
                    <Field
                      as="textarea"
                      maxLength="300"
                      name="address"
                      rows="2"
                      className="form-control"
                    />
                  </Form.Group>
                  <Form.Group controlId="projectDescription">
                    <Form.Label>Description</Form.Label>
                    <Field
                      as="textarea"
                      maxLength="300"
                      name="description"
                      rows="2"
                      className="form-control"
                    />
                    <ErrorMessage
                      name="description"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>
                  <Form.Group controlId="website">
                    <Form.Label>Website</Form.Label>
                    <Field
                      className="form-control"
                      type="text"
                      placeholder=""
                      name="website"
                    />
                    <ErrorMessage
                      name="website"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>
                  <Form.Group controlId="website">
                    <Form.Label>Tax/VAT Number</Form.Label>
                    <Tippy
                      content={`${'This will be reflected in invoices.'}`}
                      theme="light"
                      key="2"
                    >
                      <span className="p-2 d-inline-block">
                        <i className="mdi mdi-information-outline" />
                      </span>
                    </Tippy>
                    <Field
                      className="form-control"
                      type="text"
                      placeholder=""
                      name="taxNo"
                    />
                    <ErrorMessage
                      name="taxNo"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </Form.Group>
                  {breaksList && breaksList.length > 0 && (
                    <FieldArray
                      name="breaks"
                      render={(arrayHelpers) => (
                        <div>
                          <h4 className="mt-4 mb-3">Breaks</h4>
                          {formikprops.values.breaks.length > 0 &&
                            formikprops.values.breaks.map(
                              (breakItem, bIndex) => (
                                <Row key={`breaks${bIndex}`}>
                                  <Col xs={8}>
                                    <Form.Group>
                                      <Select
                                        options={breakOptions}
                                        menuPlacement="top"
                                        className="basic-multi-select"
                                        placeholder="Select Break Type"
                                        name={`breaks[${bIndex}].breakType`}
                                        onChange={(event) =>
                                          formikprops.setFieldValue(
                                            `breaks[${bIndex}].breakType`,
                                            event
                                          )
                                        }
                                        value={
                                          formikprops.values.breaks[bIndex]
                                            .breakType.value
                                            ? {
                                                label:
                                                  formikprops.values.breaks[
                                                    bIndex
                                                  ].breakType.label,
                                                value:
                                                  formikprops.values.breaks[
                                                    bIndex
                                                  ].breakType.value,
                                              }
                                            : null
                                        }
                                        theme={(theme) => ({
                                          ...theme,
                                          colors: {
                                            ...theme.colors,
                                            primary: '#0649b5',
                                            neutral10: '#edf2f9',
                                            neutral20: '#d2ddec',
                                            neutral30: '#d2ddec',
                                            neutral50: '#b1c2da',
                                            neutral80: '#12263f',
                                            dangerLight: '#DEEBFF',
                                            danger: '#12263f',
                                          },
                                        })}
                                      />
                                      <ErrorMessage
                                        name={`breaks[${bIndex}].breakType`}
                                        render={(msg) => (
                                          <small className="text-danger">
                                            {msg}
                                          </small>
                                        )}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col className="col-auto">
                                    {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                                    <label
                                      htmlFor={`breaks[${bIndex}].billable`}
                                      className="form-check-label d-flex align-items-center mt-2"
                                    >
                                      <Field
                                        type="checkbox"
                                        name={`breaks[${bIndex}].billable`}
                                        className="form-check-input mt-1 me-2"
                                      />
                                      <span className="text-muted">
                                        Productive
                                      </span>
                                    </label>
                                  </Col>

                                  <Col xs={1}>
                                    <Button
                                      variant="link"
                                      onClick={() =>
                                        arrayHelpers.remove(bIndex)
                                      }
                                    >
                                      <i className="mdi mdi-window-close" />
                                    </Button>
                                  </Col>
                                </Row>
                              )
                            )}
                          <div className="mb-4">
                            <Button
                              variant="outline-primary"
                              type="button"
                              size="sm"
                              onClick={() =>
                                arrayHelpers.push({
                                  breakType: '',
                                  billableBreak: '',
                                })
                              }
                            >
                              Add Break
                            </Button>
                          </div>
                        </div>
                      )}
                    />
                  )}
                </section>
              </Modal.Body>
              <Modal.Footer className="d-flex justify-content-between">
                <Button variant="white" onClick={handleClose}>
                  Cancel
                </Button>
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  {isSubmitting && (
                    <span
                      className="spinner-border spinner-border-sm me-1"
                      role="status"
                      aria-hidden="true"
                    />
                  )}
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

EditClientModal.propTypes = {
  selectedClient: PropTypes.object,
  handleUpdateClientsList: PropTypes.func,
  breaksList: PropTypes.array,
};

export default EditClientModal;
